import { HeaderElementDataType } from '@/components/sections/builder/elements/header/header/type';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import DynamicImage from '@/components/commons/dynamic-image';
import { cn } from '@/lib/utils';
import React from 'react';

export default function HeaderLogo({
  className,
  logoUrl,
  logoWidth,
  logoWidthMobile,
}: HeaderElementDataType & {
  className?: string;
}) {
  const query = useSearchParams();
  const themeId = query.get('theme_id') || '';
  const token = query.get('token') || '';

  if (!logoUrl) return <div className='text-lg font-bold'>LOGO</div>;

  return (
    <Link href={`/${token ? `?theme_id=${themeId}&token=${token}` : ''}`} className={cn(className)}>
      <DynamicImage
        src={logoUrl}
        alt='Logo'
        className={cn('h-auto w-[var(--logo-width-mobile)] md:w-[var(--logo-width)]')}
        style={
          {
            '--logo-width-mobile': `${logoWidthMobile || 65}px`,
            '--logo-width': `${logoWidth || 85}px`,
          } as React.CSSProperties
        }
        width={logoWidth ?? 85}
        height={0}
        data-testid='header-logo'
      />
    </Link>
  );
}
